export default {
  TableHeadFeature: [
    [
      {
        displayName: 'feature.header.number',
      },
      {
        displayName: 'feature.header.type',
      },
      {
        displayName: 'feature.header.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'feature.header.nickname',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'feature.header.status',
        attr: {
          class: 'text-center',
        },
      },
      {
        displayName: 'feature.header.action',
        attr: {
          class: 'text-center',
        },
      },
    ],
  ],
};
